module.exports = __webpack_public_path__ + "static/media/Sharp-LS032B7DD02-Mechanical-Drawing.cdcf9437.png";